<template>
  <require-access :data="statsAbac.data" :action="statsAbac.action">
    <div class="transaction-statistic__wrapper" v-if="stats.isCurrencyStats">
      <div class="transaction-currency-calculation">
        <div class="transaction-currency-calculation__header">
          <div class="title">
            <span>{{ $t('transaction-statistic.calculating-total') }}</span>
          </div>
        </div>
        <div class="transaction-currency-calculation__body">
          <div class="transaction-currency-calculation__table">
            <div class="table__header">
              <div class="currencies-block">
                <div class="cell title"></div>
                <div
                  class="cell"
                  v-for="currency in Object.keys(formattedCurrenciesStats)"
                  :key="currency"
                >
                  <div class="currency">{{ currency }}</div>
                </div>
              </div>
            </div>
            <div class="table__body">
              <div class="table__row">
                <div class="cell title">
                  {{ $t('transaction-statistic.total') }}
                </div>
                <div
                  class="cell"
                  v-for="stat in formattedCurrenciesStats"
                  :key="`total-${stat.currency}`"
                >
                  <div class="currency">{{ stat.count }}</div>
                </div>
              </div>
              <div class="table__row">
                <div class="cell title">
                  {{ $t('transaction-statistic.sum') }}
                </div>
                <div
                  class="cell"
                  v-for="stat in formattedCurrenciesStats"
                  :key="`total-${stat.currency}`"
                >
                  <div class="currency">{{ stat.sum }}</div>
                </div>
              </div>
              <div class="table__row">
                <div class="cell title">
                  {{ $t('transaction-statistic.average-check') }}
                </div>
                <div
                  class="cell"
                  v-for="stat in formattedCurrenciesStats"
                  :key="`total-${stat.currency}`"
                >
                  <div class="currency">{{ stat.midBill }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="transactions-statistic" :class="classList">
        <div class="transactions-statistic__inner">
          <stats-widget :stats="stats.typedStats"></stats-widget>
        </div>
      </div>
    </div>
  </require-access>
</template>

<script>
import StatsWidget from '@vue-app/components/company/transactions/stats/StatsWidget.vue'
import RequireAccess from '@vue-app/components/base/role-based/RequireAccess.vue'
import { Stats } from '@js-app/entities/transaction/Stats'

export default {
  name: 'TransactionsStatistic',
  components: { RequireAccess, StatsWidget },
  props: {
    stats: {
      type: Stats,
    },
    statsAbac: {
      type: Object,
      default() {
        return { data: '', action: '' }
      },
    },
    classList: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      tableData: [
        {
          title: 'Всього',
          values: [108100.0, 34100.0, 28100.0],
        },
        {
          title: 'Сума',
          values: [10100.0, 3100.0, 8100.0],
        },
        {
          title: 'Середній чек',
          values: [1100.0, 100.0, 100.0],
        },
      ],
      currencies: [
        {
          id: 1,
          currency: '',
        },
        {
          id: 2,
          currency: 'UAH',
        },
        {
          id: 3,
          currency: 'EUR',
        },
        {
          id: 4,
          currency: 'USD',
        },
      ],
    }
  },
  computed: {
    formattedCurrenciesStats() {
      let currenciesStats = {}

      this.stats.allStatsByCurrencies.forEach((stat) => {
        currenciesStats[stat.currency] = {
          sum: stat.sum,
          count: stat.count,
          midBill: stat.midBill,
        }
      })

      return currenciesStats
    },
  },
}
</script>

<style lang="scss" scoped>
.transaction-statistic__wrapper {
  display: flex;
  gap: 10px;
  height: 100%;
  .transaction-currency-calculation {
    margin-top: 15px;
    width: 750px;
    height: max-content;
    max-width: 750px;
    border-radius: 20px;
    background-color: #fff;
    padding: 20px 16px 16px 16px;

    .transaction-currency-calculation__header {
      .title {
        padding-left: 20px;
        span {
          font-size: 16px;
          font-weight: 600;
          color: #27365b;
        }
      }
    }

    .transaction-currency-calculation__body {
      .transaction-currency-calculation__table {
        margin-top: 20px;
        border: 1px solid #f5f7fb;
        border-radius: 8px;
        .table__header {
          .currencies-block {
            display: flex;
            .cell {
              padding: 10px;
              flex: 1;
              border-right: 1px solid #f5f7fb;

              .currency {
                font-size: 12px;
                font-weight: 500;
                line-height: 28px;
                color: #909cb0;
              }

              &:last-child {
                border-right: none;
              }
            }
          }
        }

        .table__body {
          .table__row {
            display: flex;
            width: 100%;
            .cell {
              padding: 10px;
              flex: 1;
              border-right: 1px solid #f5f7fb;
              border-top: 1px solid #f5f7fb;
              &.title {
                font-size: 12px;
                font-weight: 500;
                color: #909cb0;
              }

              &:last-child {
                border-right: none;
              }

              &:first-child {
                border-top: 1px solid #f5f7fb;
              }

              .currency {
                font-size: 14px;
                font-weight: 500;
                color: #465a8b;
              }
            }
          }
        }
      }
    }
  }
}
.transactions-statistic {
  width: 100%;
  &__inner {
    width: 100%;
    max-width: 629px;
    display: flex;
    align-items: stretch;
    padding: 20px;
    background: #ffffff;
    border-radius: 8px;
  }

  &__col {
    width: calc(25% - 35px);
    margin-right: 40px;

    &:last-child {
      margin-right: 0;
    }
  }

  &__separator {
    margin-right: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 5px;
    height: 100%;
    flex-shrink: 0;
    flex-grow: 0;

    svg {
      width: 100%;
      height: 100%;
    }
  }

  &__title {
    font-weight: 500;
    font-size: 11px;
    line-height: 28px;
    color: #000;
    white-space: nowrap;
    margin-bottom: 10px;

    &--active {
      color: #4e92d1;
    }

    &--paid {
      color: #27cc24;
    }

    &--refund {
      color: #f18724;
    }

    &--partial-refund {
      color: #f18724;
    }
  }

  &__label {
    font-weight: 300;
    font-size: 11px;
    line-height: 28px;
    color: #909cb0;
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__value {
    font-weight: 600;
    font-size: 12px;
    line-height: 28px;
    color: #585f6d;
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
@media screen and (max-width: 992px) {
  .transactions-statistic {
    padding: 17px 35px 30px;
    &__inner {
      display: flex;
      flex-direction: column;
      max-width: unset;
    }

    &__col {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 15px;

      &:last-child {
        margin-bottom: 0;
      }

      &--titles {
        width: calc(100% + 70px);
        margin-left: -35px;
        padding-bottom: 15px;
        padding-left: 35px;
        padding-right: 35px;
        border-bottom: 1px solid #eff2f8;
        margin-bottom: 22px;
      }
    }

    &__label,
    &__title,
    &__value {
      width: calc(33.33333% - 5px);
      line-height: 14px;
      margin-bottom: 0;
      white-space: unset;
    }

    &__separator {
      display: none;
    }
  }
}
</style>
